import { render, staticRenderFns } from "./TambahAtasanPegawai.vue?vue&type=template&id=5fe52aa1&scoped=true"
import script from "./TambahAtasanPegawai.vue?vue&type=script&lang=js"
export * from "./TambahAtasanPegawai.vue?vue&type=script&lang=js"
import style0 from "./TambahAtasanPegawai.vue?vue&type=style&index=0&id=5fe52aa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe52aa1",
  null
  
)

export default component.exports